export default "__VITE_ASSET__De$fT8Sx__"